import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-af7746e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "public-comment-model" }
const _hoisted_2 = { class: "public-comment-content" }
const _hoisted_3 = {
  key: 0,
  class: "rate-box"
}
const _hoisted_4 = { class: "rate-item" }
const _hoisted_5 = { class: "rate-label" }
const _hoisted_6 = { class: "comment-file-remark" }
const _hoisted_7 = { class: "add-refund-title" }

import { reactive, ref, watch } from 'vue'
import { useRoute, useRouter } from "vue-router";
import { Toast } from 'vant';
import KiliButton from "@/components/KiliButton.vue";
import UploadFile from "@/components/upload/upload.vue";
import $http from '@/plugins/http';
import { getFilePath } from '@/hooks/index'
import md5 from 'js-md5';
interface RateList {
    label: string, // 评分label
    rate: number, // 评分
    default: boolean, //是否为评分主体 false为否,true为是. 为评分主体时,发起评分请求时,将文件相关的数据放在该元素的中
}
/** 新增评论的传参 */
interface paramsType {
                    userId: string, // 登录用户ID
                    orderId: string, // 订单ID
                    commentId?: string, // 评论ID
                    commentObjectId: string, // 评论对象的ID（类型为1时传商品listingID；类型为2或3时传店铺ID；类型为4时传快递员ID，类型为5时传自提点ID）
                    commentObjectType: string, // 评论对象的类型（1、商品评论；2、店铺服务评论；3、店铺发货速度评论；4、快递员评论；5、自提点评论）
                    commentContents?: string, // 评论内容
                    isAnonymous: string, // 是否匿名(0非匿名,1匿名)
                    isAutoReply?: string, // 是否自动回复
                    isReported?: string, // 是否举报
                    extContents?: string, // 扩展字段
                    languageCode: string, // 国家字段(语言编码)
                    sign?: string, // 签名
                    ipAddress?:string, //发表评论的IP地址
                    scoreValue?: string, // 评分
                    commentCreateTime?: string, // 评论创建时间
                    // 评论附件  放在主体评论对象中,也就是commentObjectType指定的评论对象类型的评论数据下
                    commentMediaFormList?:[{
                        mediaType:string,
                        content:string,
                    }],
                    // 评论标签 有标签时传
                    commentTagLogFormList?: [
                        {
                            userId: string, //登录用户ID
                            tagId: string, //标签ID
                            objectId: string //评论对象ID
                        }
                    ],
                }

export default /*#__PURE__*/_defineComponent({
  __name: 'public-comment',
  props: {
    // 当新增评论请求完成之后,需要执行的函数
    exclusiveFn:{
        type:Function,
        default:()=>{

        }
    },
    // 评分类型 Array<Object>
    rateList:{
        type:Array,
        default:():Array<RateList> => {
            return []
        }
    },
    // 获取或者设置图片拼接路径
    uploadPath:{
        required:true,
        type:String,
        // default:'aftersale/202201/'
    },
    // 支持的可上传文件类型
    accept:{
        type:String,
         default:"image/*, video/mp4" // 默认支持的可上传类型及格式
    },
    title_name: {
        type: String,
        default: 'Proof description:'
    },
    content_placeholder: {
        type: String,
        default: ''
    },
    // remark下的提示语
    textAreaCon:{
        type:String,
        default:'Detailed description and proofs will help us process faster. (Picture Size <10M, Video <1 minute)'
    },
    // 是否显示上传
    showUpload:{
        type:Boolean,
        default:true
    },
    // 是否进行评论提交 默认为false 组件中会监听该属性的变化,当其为true时会自动触发评论提交
    isSubmit:{
        type:Boolean,
        default:false
    },
    // 进行评论时所需的独特参数
    paramsData:{
        type: Object,
        default:()=>{
            return {}
        }
    }
},
  emits: ['update:isSubmit'],
  setup(__props, { emit }) {

const props = __props

const router = useRouter()
const route = useRoute()
/** 评论评星级 */


let teaxAreaVal = ref('')
let btnData = reactive({
        textColor: '#E04545',
        bordersColor: '#E04545',
        radiusSize: '6px',
        title: 'Submit',
        loading:false
    })
let imgPathData:any = ref({})
/**fileStorage数组内对象： 
 * {
 * content: '', // 上传时返回的文件拼接路径
    attach_type: 1, // 文件类型 1：图片 2：视频
    }
 */
let fileStorage:Array<any> = reactive([])
// 获取视频/图片拼接路径及格式信息
getFilePath().then((res:any)=>{
        imgPathData.value = res
        imgPathData.value.path = props.uploadPath
})
// 上传的文件
const handleUpload = (data: any) => {
    fileStorage.push({mediaType:data.attach_type,content: data.content})
}
// 删除文件
const delFile=(file:any)=>{
        fileStorage=file
}
// 触发新增评论的提交
const addComment = async () => {
    emit("update:isSubmit",false)
    // 提交评论
    let params:Array<paramsType> = []
    let commentItem:any = {
            scoreValue:'5',
            ipAddress: '10.0.3.188',
            commentContents: teaxAreaVal.value ? teaxAreaVal.value:'',
            ...props.paramsData
        }
    if(props.rateList.length){
        // 存在评分情况
            props.rateList.forEach((item: any) => {
            commentItem.scoreValue = item.rate
            item.default&&fileStorage.length ? commentItem.commentMediaFormList = fileStorage:''
            let signStr = `12345678${JSON.stringify(commentItem)}12345678`  
            commentItem.sign= md5(signStr)
            params.push(commentItem)
        })
    }else{
        // 不存在评分情况
        fileStorage.length ? commentItem.commentMediaFormList = fileStorage:''
        let signStr:string = `12345678${JSON.stringify(commentItem)}12345678`  
        commentItem.sign= md5(signStr)
        params.push(commentItem)
    }
    let str = teaxAreaVal.value
    if(!str.replace(/\s/g,'').length) { Toast("Please enter the  review"); return}
    const res: any = await $http.setComment(params)
        if (res.code === 200) {
            // 请求成功,调用父组件传入的函数
            props.exclusiveFn()
        }else{
            Toast(res.message)
        }

}
watch(()=>props.isSubmit,()=>{
    if(props.isSubmit){
        addComment()
    }
})

return (_ctx: any,_cache: any) => {
  const _component_van_rate = _resolveComponent("van-rate")!
  const _component_van_field = _resolveComponent("van-field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "rate"),
      (__props.rateList.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.rateList, (item) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("p", _hoisted_5, _toDisplayString(item.title), 1),
                _createVNode(_component_van_rate, {
                  modelValue: item.rate,
                  "onUpdate:modelValue": ($event: any) => ((item.rate) = $event),
                  size: "0.77rem",
                  gutter: "0.69rem"
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ]))
            }), 256))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("span", _hoisted_7, _toDisplayString(__props.title_name), 1),
        (__props.showUpload)
          ? (_openBlock(), _createBlock(UploadFile, {
              key: 0,
              onUpload: handleUpload,
              onDelFile: delFile,
              imgPathData: _unref(imgPathData),
              accept: __props.accept
            }, null, 8, ["imgPathData", "accept"]))
          : _createCommentVNode("", true),
        _createVNode(_component_van_field, {
          modelValue: _unref(teaxAreaVal),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(teaxAreaVal) ? (teaxAreaVal).value = $event : teaxAreaVal = $event)),
          placeholder: __props.content_placeholder,
          "left-icon": _unref(teaxAreaVal) && _unref(teaxAreaVal).length > 0 ? ' ' : 'edit',
          type: "textarea",
          maxlength: "500",
          "show-word-limit": "",
          clearable: ""
        }, null, 8, ["modelValue", "placeholder", "left-icon"]),
        _createElementVNode("p", null, _toDisplayString(__props.textAreaCon), 1)
      ])
    ]),
    _renderSlot(_ctx.$slots, "btn"),
    _createVNode(KiliButton, {
      class: "hide_button",
      textColor: _unref(btnData).textColor,
      bordersColor: _unref(btnData).bordersColor,
      radiusSize: _unref(btnData).radiusSize,
      title: _unref(btnData).title,
      loading: _unref(btnData).loading,
      onClick: addComment
    }, null, 8, ["textColor", "bordersColor", "radiusSize", "title", "loading"])
  ]))
}
}

})